'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleSheets = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleSheets, _SvgIcon);

  function GoogleSheets() {
    _classCallCheck(this, GoogleSheets);

    return _possibleConstructorReturn(this, (GoogleSheets.__proto__ || Object.getPrototypeOf(GoogleSheets)).apply(this, arguments));
  }

  _createClass(GoogleSheets, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            fill: '#43a047',
            d: 'M294.52,347.84h-183a21.12,21.12,0,0,1-21.12-21.12V73.28a21.12,21.12,0,0,1,21.12-21.12H245.24l70.4,70.4V326.72A21.12,21.12,0,0,1,294.52,347.84Z'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#c8e6c9',
            points: '315.64 122.56 245.24 122.56 245.24 52.16 315.64 122.56'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#2e7d32',
            points: '245.24 122.56 315.64 192.96 315.64 122.56 245.24 122.56'
          }),
          _react2['default'].createElement('path', {
            fill: '#e8f5e9',
            d: 'M252.28,193H139.64v98.56H266.36V193H252.28ZM153.72,207h28.16v14.08H153.72V207Zm0,28.16h28.16v14.08H153.72V235.2Zm0,28.16h28.16v14.08H153.72V263.36Zm98.56,14.08H196V263.36h56.32v14.08Zm0-28.16H196V235.2h56.32v14.08Zm0-28.16H196V207h56.32v14.08Z'
          })
        );
      }

      return render;
    }()
  }]);

  return GoogleSheets;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 400 400'
}, _temp);
exports['default'] = GoogleSheets;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/GoogleSheets.js
// module id = 1375
// module chunks = 32